// extracted by mini-css-extract-plugin
export default {"accordion":"AccordionWrapper_accordion__UmMt0"};